import React from 'react';
import styles from './SubTypeSelector.module.scss';
import {MDBCol, MDBRow} from 'mdbreact';
import {Route, Switch} from 'react-router';
import VoucherOrOrderRadio, {IVoucherOrOrderRadioProps} from './components/voucherOrOrderRadio/VoucherOrOrderRadio';

interface IRadioSelectors {
  [key: string]: IVoucherOrOrderRadioProps;
}

interface ICustomSelectors {
  [key: string]: any;
}

export interface ISubTypeSelectorProps {
  radioSelectors?: IRadioSelectors;
  customSelectors?: ICustomSelectors;
  state?: any;
  setState?: any;
}

const SubTypeSelector = (props: ISubTypeSelectorProps) => {
  if (props.state.activeStep === 0) {
    return <MDBRow className={styles.selectorsContainer}>
      <MDBCol style={{padding: 0}}>
        <Switch>
          {Object.keys(props.radioSelectors).map(path =>
            <Route key={path} path={path}>
              <VoucherOrOrderRadio
                {...props.radioSelectors[path]}
              />
            </Route>)}
          {Object.keys(props.customSelectors).map(path => {
            const C: any = props.customSelectors[path];
            return <Route key={path} path={path}>
              <C {...props}/>
            </Route>;
          })}
        </Switch>
      </MDBCol>
    </MDBRow>;
  }
  return null;
};

SubTypeSelector.defaultProps = {
  radioSelectors: [],
  customSelectors: [],
};

export default SubTypeSelector;
